var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useState, } from 'react';
// ******* CONTEXT ******
export var EditDeliveryAddressContext = createContext(undefined);
// ******* PROVIDER ******
export var EditDeliveryAddressProvider = function (_a) {
    var children = _a.children;
    var _b = useState({
        firstNameValue: '',
        lastNameValue: '',
        streetAddressValue: '',
        addressLineTwoValue: null,
        zipCodeValue: '',
        cityStateValue: '',
        phoneNumberValue: '',
    }), formState = _b[0], setFormState = _b[1];
    var _c = useState([]), deliveryAddresses = _c[0], setDeliveryAddresses = _c[1];
    var _d = useState(false), showCalendar = _d[0], setShowCalendar = _d[1];
    var _e = useState(false), requireSignature = _e[0], setRequireSignature = _e[1];
    var _f = useState(null), availableDeliverySlotsResponse = _f[0], setAvailableDeliverySlotsResponse = _f[1];
    var _g = useState(null), selectedDateId = _g[0], setSelectedDateId = _g[1];
    var _h = useState([]), availableDeliverySlots = _h[0], setAvailableDeliverySlots = _h[1];
    var _j = useState(''), deliveryDate = _j[0], setDeliveryDate = _j[1];
    var _k = useState(null), selectedDeliverySlot = _k[0], setSelectedDeliverySlot = _k[1];
    var _l = useState(false), isEligibilityChecked = _l[0], setIsEligibilityChecked = _l[1];
    var _m = useState(false), isEligible = _m[0], setIsEligible = _m[1];
    var _o = useState(''), selectedAddressId = _o[0], setSelectedAddressId = _o[1];
    var updateFormField = function (fields) {
        setFormState(function (prev) { return (__assign(__assign({}, prev), fields)); });
    };
    return (React.createElement(EditDeliveryAddressContext.Provider, { value: {
            formState: formState,
            updateFormField: updateFormField,
            deliveryAddresses: deliveryAddresses,
            setDeliveryAddresses: setDeliveryAddresses,
            showCalendar: showCalendar,
            setShowCalendar: setShowCalendar,
            requireSignature: requireSignature,
            setRequireSignature: setRequireSignature,
            availableDeliverySlots: availableDeliverySlots,
            setAvailableDeliverySlots: setAvailableDeliverySlots,
            availableDeliverySlotsResponse: availableDeliverySlotsResponse,
            setAvailableDeliverySlotsResponse: setAvailableDeliverySlotsResponse,
            selectedDateId: selectedDateId,
            setSelectedDateId: setSelectedDateId,
            deliveryDate: deliveryDate,
            setDeliveryDate: setDeliveryDate,
            selectedDeliverySlot: selectedDeliverySlot,
            setSelectedDeliverySlot: setSelectedDeliverySlot,
            isEligibilityChecked: isEligibilityChecked,
            setIsEligibilityChecked: setIsEligibilityChecked,
            isEligible: isEligible,
            setIsEligible: setIsEligible,
            selectedAddressId: selectedAddressId,
            setSelectedAddressId: setSelectedAddressId,
        } }, children));
};
